import { MousePointerClick, CreditCard, BellRing } from "lucide-react";
import { Reveal } from "@/lib/Reveal";

const STEPS = [
  { icon: MousePointerClick, title: "Pick your service & slot", text: "Choose the job, pick a day and time window that suits you." },
  { icon: CreditCard, title: "Pay securely online", text: "Fixed price, card payment via Stripe. No hidden extras, ever." },
  { icon: BellRing, title: "We confirm & turn up", text: "Your booking is confirmed ASAP by text and email — then a Gas Safe engineer arrives in your window." },
];

export const HowItWorks = () => {
  return (
    <section data-testid="how-it-works" className="py-14 lg:py-16 bg-[#0C0C0C] border-b border-white/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12">
        <Reveal>
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-neutral-500 text-center mb-10">
            Booked, paid and confirmed in under two minutes
          </p>
        </Reveal>
        <div className="grid sm:grid-cols-3 gap-8 sm:gap-6">
          {STEPS.map((s, i) => (
            <Reveal key={s.title} delay={i * 0.12}>
              <div className="flex sm:flex-col items-start sm:items-center gap-4 sm:text-center relative">
                <div className="relative shrink-0">
                  <span className="w-14 h-14 rounded-full bg-torch/10 border border-torch/40 flex items-center justify-center">
                    <s.icon className="w-6 h-6 text-torch" />
                  </span>
                  <span className="absolute -top-1.5 -right-1.5 w-6 h-6 rounded-full bg-torch text-white font-display font-bold text-xs flex items-center justify-center">
                    {i + 1}
                  </span>
                </div>
                <div>
                  <h3 className="font-display font-bold text-white">{s.title}</h3>
                  <p className="mt-1.5 text-sm text-neutral-400 leading-relaxed sm:max-w-xs sm:mx-auto">{s.text}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
